import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function PolicyPage() {
  const { handle } = useParams();
  const [policy, setPolicy] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setPolicy(null); setNotFound(false);
    api.getPolicy(handle).then(setPolicy).catch(() => setNotFound(true));
  }, [handle]);

  return (
    <div className="pt-16" data-testid="policy-page">
      {policy?.title && (
        <Seo title={`${policy.title} | The Recovery Shops`}
          description={`Read the ${policy.title} for The Recovery Shops — our commitment to clear, fair terms for every customer.`} />
      )}
      <div className="bg-charcoal border-b border-white/10">
        <div className="max-w-3xl mx-auto px-5 py-14">
          <p className="overline">Policies</p>
          <h1 className="font-serif text-4xl sm:text-5xl text-cream mt-2">
            {policy?.title || (notFound ? "Not Found" : "Loading…")}
          </h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-5 py-12">
        {notFound ? (
          <p className="text-cream/60">This policy isn't available.</p>
        ) : policy ? (
          <div className="rich" data-testid="policy-body"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(policy.body) }} />
        ) : (
          <p className="text-cream/60">Loading…</p>
        )}
      </div>
    </div>
  );
}
